import { render, staticRenderFns } from "./survey-question-set-answering.vue?vue&type=template&id=0380dbc7&scoped=true"
import script from "./survey-question-set-answering.vue?vue&type=script&lang=js"
export * from "./survey-question-set-answering.vue?vue&type=script&lang=js"
import style0 from "./survey-question-set-answering.vue?vue&type=style&index=0&id=0380dbc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0380dbc7",
  null
  
)

export default component.exports